import { render } from "./Typosquatting.vue?vue&type=template&id=63eb5b3c&scoped=true"
import script from "./Typosquatting.vue?vue&type=script&lang=js"
export * from "./Typosquatting.vue?vue&type=script&lang=js"

import "./Typosquatting.vue?vue&type=style&index=0&id=63eb5b3c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63eb5b3c"]])

export default __exports__